import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const reasonSchema = yup.object().shape({
	name: yup.string().trim().required(MSG.REQUIRED_NAME),
	description: yup.string().trim().required(MSG.REQUIRED_DESCRIPTION),
	type: yup
		.array()
		.of(yup.object({ label: yup.string(), value: yup.string() }))
		.min(1, MSG.REQUIRED_TYPE)
		.required(MSG.REQUIRED_TYPE),
});
